import { buildApiUrl } from '../../utils/api';
import { setCookie } from "../../utils/cookies";

export const createOtpAuthSlice = (set, get) => ({
  isAuthModalOpen: false,
  otpLoading: false,
  otpError: null,
  otpSent: false,
  mobileNumber: null,

  sendOtp: async (mobile, name = '', referral_code = '') => {
    set({ otpLoading: true, otpError: null, otpSent: false, mobileNumber: mobile });
    try {
      const response = await fetch(buildApiUrl('api/v1/customer/send-otp'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobile: Number(mobile),
          ...(name?.trim() ? { name: name.trim() } : {}),
          ...(referral_code?.trim() ? { referral_code: referral_code.trim() } : {}),
        }),
      });

      const textResponse = await response.text();
      let data = {};
      try {
        data = JSON.parse(textResponse);
      } catch (e) {
        // ignore non-JSON responses
      }

      if (response.ok && data.success !== false) {
        set({
          otpSent: true,
          otpLoading: false,
          otpError: null,
        });
        return { success: true, data };
      }

      throw new Error(data.message || "Failed to send OTP");
    } catch (error) {
      set({ otpError: error.message, otpLoading: false, otpSent: false });
      throw error;
    }
  },

  verifyOtp: async (mobile, otp, name = '', referral_code = '') => {
    set({ otpLoading: true, otpError: null });
    try {
      const body = {
        mobile: String(mobile),
        otp: String(otp),
      };
      if (name?.trim()) body.name = name.trim();
      if (referral_code?.trim()) body.referral_code = referral_code.trim();

      const response = await fetch(buildApiUrl('api/v1/customer/verify-otp'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const textResponse = await response.text();
      let data = {};
      try {
        data = JSON.parse(textResponse);
      } catch (e) {
        // ignore non-JSON responses
      }

      if (response.ok && data.success !== false) {
        set({
          isAuthenticated: true,
          user: data.data?.customer || data.data || data.user || { mobile },
          otpLoading: false,
          otpError: null,
          otpSent: false,
        });

        const token = data.token || data.data?.token || data.access_token || data.data?.access_token;

        if (token) {
          setCookie("authToken", token, 7);
          // Merge guest cart + fetch server cart + fetch wishlist after login
          setTimeout(async () => {
            if (typeof get().mergeGuestCartOnLogin === "function") {
              await get().mergeGuestCartOnLogin();
            } else if (typeof get().fetchCart === "function") {
              get().fetchCart();
            }
            if (typeof get().fetchWishlist === "function") {
              get().fetchWishlist();
            }
          }, 100);
        } else {
          // No token in response — cookie not set
        }

        return { success: true, data };
      }

      throw new Error(data.message || "Invalid OTP");
    } catch (error) {
      set({ otpError: error.message, otpLoading: false });
      throw error;
    }
  },

  resetOtpState: () => {
    set({
      otpLoading: false,
      otpError: null,
      otpSent: false,
      mobileNumber: null,
    });
  },

  openAuthModal: () => set({ isAuthModalOpen: true }),

  closeAuthModal: () => {
    set({ isAuthModalOpen: false });
    get().resetOtpState();
  },
});
